import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form, InputNumber } from 'antd';

export function Greater(): JSX.Element {
	return (
		<Col span={12}>
			<Form.Item name="min_overall_score" label={I18n.get('Minimum')} labelCol={{ span: 24 }}>
				<InputNumber controls={false} placeholder={I18n.get('Minimum')} />
			</Form.Item>
		</Col>
	);
}
